const KEY = "pdp-recently-viewed-v2";

export const getData = () => {
  try {
    const data = JSON.parse(localStorage.getItem(KEY)) || [];
    const now = Date.now();

    // 1 week
    const expiry = 1000 * 60 * 60 * 24 * window.theme.recentlyViewedExpiry;

    return data.filter(
      (product) => product.savedAt && now - product.savedAt < expiry,
    );
  } catch (e) {
    return [];
  }
};

export const saveData = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data));
};
